module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', [_c('div', {
    staticClass: "modal"
  }, [_c('v-dialog', {
    attrs: {
      "value": _vm.value,
      "persistent": "",
      "transition": "fade-transition",
      "fullscreen": "",
      "no-click-animation": "",
      "content-class": "ims-standard-dialog"
    },
    on: {
      "input": function($event) {
        return _vm.$emit('input')
      }
    }
  }, [_c('v-card', {
    staticClass: "ims-modal-card"
  }, [_c('v-toolbar', {
    staticClass: "pairing-modal-toolbar",
    attrs: {
      "color": "#3F3FFF",
      "dark": "",
      "elevation": 1
    }
  }, [_c('v-toolbar-title', {
    staticClass: "pairing-modal-title-wrap"
  }, [_c('h3', {
    staticClass: "text-xs-center white--text pairing-modal-title",
    staticStyle: {
      "font-size": "1.25rem"
    }
  }, [_vm._v("\n                Pair influencers for campaign:\n                "), _c('strong', [_vm._v(_vm._s(_vm.campaign.name))])])]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "pairing-modal-close",
    attrs: {
      "icon": "",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.close
    }
  }, [_c('v-icon', [_vm._v("mdi-close")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "modal-content ims-modal-body"
  }, [_c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "column": ""
    }
  }, [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "3",
      "xs": "12"
    }
  }, [_c('v-hover', {
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var hover = ref.hover;

        return [_c('v-card', {
          class: {
            'on-hover': hover
          },
          attrs: {
            "color": "#363636",
            "dark": "",
            "elevation": hover ? 12 : 2
          }
        }, [_c('v-card-title', {
          staticClass: "headline"
        }, [_vm._v("Contents")]), _vm._v(" "), _c('v-card-subtitle', [_c('p', {
          staticClass: "pa-0 ma-0 custom-font"
        }, [_vm._v("Target : " + _vm._s(_vm.campaign.min_content) + " to " + _vm._s(_vm.campaign.max_content))]), _vm._v(" "), _c('p', {
          staticClass: "pa-0 ma-0 custom-font"
        }, [_vm._v("Current Total: " + _vm._s(_vm.measurement.total))]), _vm._v(" "), _c('p', {
          staticClass: "pa-0 ma-0 custom-font"
        }, [_vm._v("Percentage: " + _vm._s(_vm.measurement.totalPercentage) + "%")])])], 1)]
      }
    }])
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "3",
      "xs": "12"
    }
  }, [_c('v-hover', {
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var hover = ref.hover;

        return [_c('v-card', {
          class: {
            'on-hover': hover
          },
          attrs: {
            "color": "#363636",
            "dark": "",
            "elevation": hover ? 12 : 2
          }
        }, [_c('v-card-title', {
          staticClass: "headline"
        }, [_vm._v("Outreach")]), _vm._v(" "), _c('v-card-subtitle', [_c('p', {
          staticClass: "pa-0 ma-0 custom-font"
        }, [_vm._v("Target : " + _vm._s(_vm._f("thousandSeprator")(_vm.campaign.outreach)))]), _vm._v(" "), _c('p', {
          staticClass: "pa-0 ma-0 custom-font"
        }, [_vm._v("Current Total: " + _vm._s(_vm._f("thousandSeprator")(_vm.measurement.outreach)))]), _vm._v(" "), _c('p', {
          staticClass: "pa-0 ma-0 custom-font"
        }, [_vm._v("Percentage: " + _vm._s(_vm.measurement.outreachPercentage) + "%")])])], 1)]
      }
    }])
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "3",
      "xs": "12"
    }
  }, [_c('v-hover', {
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var hover = ref.hover;

        return [_c('v-card', {
          class: {
            'on-hover': hover
          },
          attrs: {
            "color": "#363636",
            "dark": "",
            "elevation": hover ? 12 : 2
          }
        }, [_c('v-card-title', {
          staticClass: "headline"
        }, [_vm._v("Engagement")]), _vm._v(" "), _c('v-card-subtitle', [_c('p', {
          staticClass: "pa-0 ma-0 custom-font"
        }, [_vm._v("Target : " + _vm._s(_vm._f("thousandSeprator")(_vm.campaign.engagement)))]), _vm._v(" "), _c('p', {
          staticClass: "pa-0 ma-0 custom-font"
        }, [_vm._v("Current Total: " + _vm._s(_vm._f("thousandSeprator")(_vm.measurement.engagement)))]), _vm._v(" "), _c('p', {
          staticClass: "pa-0 ma-0 custom-font"
        }, [_vm._v("Percentage: " + _vm._s(_vm.measurement.engagementPercentage) + "%")])])], 1)]
      }
    }])
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "3"
    }
  }, [_c('v-hover', {
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var hover = ref.hover;

        return [_c('v-card', {
          class: {
            'on-hover': hover
          },
          attrs: {
            "color": "#363636",
            "dark": "",
            "elevation": hover ? 12 : 2
          }
        }, [_c('v-card-title', {
          staticClass: "headline"
        }, [_vm._v("COGS")]), _vm._v(" "), _c('v-card-subtitle', [_c('p', {
          staticClass: "pa-0 ma-0 custom-font"
        }, [_vm._v("Capped : " + _vm._s(_vm._f("currency")(_vm.budget)))]), _vm._v(" "), _c('p', {
          staticClass: "pa-0 ma-0 custom-font"
        }, [_vm._v("Current: " + _vm._s(_vm._f("currency")(_vm.measurement.budget)))]), _vm._v(" "), _vm._l((_vm.currencyTotals), function(item, index) {
          return _c('span', {
            key: index
          }, [(index !== 'SGD' && item) ? _c('p', {
            staticClass: "pa-0 ma-0 custom-font"
          }, [_vm._v("Total " + _vm._s(index) + ": " + _vm._s(_vm.utilsFunc.currencySym(index)) + " " + _vm._s(_vm._f("thousandSeprator")(item)))]) : _vm._e()])
        }), _vm._v(" "), _c('p', {
          staticClass: "pa-0 ma-0 custom-font"
        }, [_vm._v("Percentage: " + _vm._s(_vm.measurement.cogsPercentage) + "%")])], 2)], 1)]
      }
    }])
  })], 1)], 1), _vm._v(" "), _c('v-row', {
    staticStyle: {
      "justify-content": "center"
    }
  }, [_c('v-col', {
    staticClass: "col-md-12 col-xs-12",
    attrs: {
      "align": "center"
    }
  }, [_c('div', {
    staticClass: "d-flex flex-row"
  }, [_c('h3', {
    staticClass: "mr-5 pa-2 pt-1"
  }, [_vm._v("Add Creators")]), _vm._v(" "), _c('v-select', {
    staticClass: "mt-3",
    staticStyle: {
      "max-width": "250px",
      "margin-right": "10px"
    },
    attrs: {
      "items": _vm.searchMethods,
      "outlined": "",
      "attach": ""
    },
    model: {
      value: (_vm.searchType),
      callback: function($$v) {
        _vm.searchType = $$v
      },
      expression: "searchType"
    }
  }), _vm._v(" "), (_vm.searchType === _vm.SearchTypeEnum.HANDLE) ? _c('v-text-field', {
    staticClass: "mt-3 pr-2",
    attrs: {
      "label": _vm.searchInfluencer === 'Youtube' ? 'Enter Handle' : 'Enter handle',
      "hide-details": "",
      "outlined": ""
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.searchManually(_vm.searchType)
      }
    },
    model: {
      value: (_vm.igHandle),
      callback: function($$v) {
        _vm.igHandle = $$v
      },
      expression: "igHandle"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.searchType === _vm.SearchTypeEnum.HANDLE) ? _c('v-select', {
    staticClass: "mt-3 mr-2",
    staticStyle: {
      "max-width": "200px"
    },
    attrs: {
      "items": _vm.searchInfluencerTypes,
      "item-text": "text",
      "item-value": "value",
      "outlined": "",
      "attach": ""
    },
    scopedSlots: _vm._u([{
      key: "selection",
      fn: function(ref) {
        var item = ref.item;

        return [(item.imgIcon) ? _c('img', {
          staticClass: "mr-2",
          style: (item.iconFilter ? ("filter: " + (item.iconFilter) + " !important;") : ''),
          attrs: {
            "src": item.imgIcon,
            "width": "20px",
            "alt": "",
            "aria-hidden": "true"
          }
        }) : _c('v-icon', {
          staticClass: "mr-2",
          style: (("color: " + (item.iconColor) + " !important;")),
          attrs: {
            "size": "20"
          }
        }, [_vm._v(_vm._s(item.icon))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(item.text))])]
      }
    }, {
      key: "item",
      fn: function(ref) {
        var item = ref.item;

        return [(item.imgIcon) ? _c('img', {
          staticClass: "mr-2",
          style: (item.iconFilter ? ("filter: " + (item.iconFilter) + " !important;") : ''),
          attrs: {
            "src": item.imgIcon,
            "width": "20px",
            "alt": "",
            "aria-hidden": "true"
          }
        }) : _c('v-icon', {
          staticClass: "mr-2",
          style: (("color: " + (item.iconColor) + " !important;")),
          attrs: {
            "size": "20"
          }
        }, [_vm._v(_vm._s(item.icon))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(item.text))])]
      }
    }], null, false, 1476219676),
    model: {
      value: (_vm.searchInfluencer),
      callback: function($$v) {
        _vm.searchInfluencer = $$v
      },
      expression: "searchInfluencer"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.searchType === _vm.SearchTypeEnum.HANDLE && _vm.searchInfluencer === 'Others') ? _c('v-text-field', {
    staticClass: "mt-3 mr-2 pl-2",
    attrs: {
      "label": "Enter Platform Name",
      "hide-details": "",
      "outlined": ""
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.searchManually(_vm.searchType)
      }
    },
    model: {
      value: (_vm.platformName),
      callback: function($$v) {
        _vm.platformName = $$v
      },
      expression: "platformName"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.searchType === _vm.SearchTypeEnum.KEYWORD) ? _c('k-influencer-search-box', {
    attrs: {
      "search": _vm.searchKeywordAction
    },
    on: {
      "result": _vm.resultFromSearchKeyword
    }
  }) : _vm._e(), _vm._v(" "), (_vm.searchType === _vm.SearchTypeEnum.KEYWORD) ? _c('v-btn', {
    staticClass: "mt-5 mr-2",
    staticStyle: {
      "min-height": "40px"
    },
    attrs: {
      "disabled": !_vm.historySearchResult,
      "color": "secondary"
    },
    on: {
      "click": function($event) {
        return _vm.showResult(_vm.historySearchResult)
      }
    }
  }, [_vm._v("View results")]) : _vm._e(), _vm._v(" "), (_vm.searchType === _vm.SearchTypeEnum.BULKUPLOAD) ? _c('v-btn', {
    staticClass: "mt-4",
    attrs: {
      "color": "secondary",
      "large": ""
    },
    on: {
      "click": function($event) {
        return _vm.$refs.igBulkHandle.click()
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "left": ""
    }
  }, [_vm._v("mdi-home-import-outline")]), _vm._v("Import Excel\n                    ")], 1) : _vm._e(), _vm._v(" "), (_vm.searchType === _vm.SearchTypeEnum.BULKUPLOAD) ? _c('v-btn', {
    staticClass: "ml-2 mt-4",
    attrs: {
      "color": "secondary",
      "large": ""
    },
    on: {
      "click": _vm.downloadSampleUpload
    }
  }, [_c('v-icon', {
    attrs: {
      "left": ""
    }
  }, [_vm._v("mdi-file-excel")]), _vm._v("Download Sample Import\n                    ")], 1) : _vm._e(), _vm._v(" "), (_vm.searchType !== _vm.SearchTypeEnum.BULKUPLOAD) ? _c('v-btn', {
    staticClass: "mt-5",
    staticStyle: {
      "min-width": "150px",
      "min-height": "40px"
    },
    attrs: {
      "color": "secondary"
    },
    on: {
      "click": function($event) {
        return _vm.searchManually(_vm.searchType)
      }
    }
  }, [_vm._v("ADD")]) : _vm._e()], 1), _vm._v(" "), _c('input', {
    ref: "igBulkHandle",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "file",
      "accept": ".xlsx",
      "id": "igBulkHandle"
    },
    on: {
      "change": _vm.igHandleBulkUpload
    }
  })])], 1), _vm._v(" "), _c('v-row', {
    staticClass: "pairing-control-row",
    attrs: {
      "align": "center"
    }
  }, [_c('v-col', {
    staticClass: "pairing-primary-controls",
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "7",
      "lg": "7"
    }
  }, [_c('div', {
    staticClass: "pairing-toolbar-actions"
  }, [(_vm.disableLockedCOGS) ? _c('v-chip', {
    staticClass: "pairing-toolbar-chip",
    attrs: {
      "color": "error"
    }
  }, [_c('v-icon', _vm._g({
    attrs: {
      "small": "",
      "left": ""
    }
  }, _vm.on), [_vm._v("mdi-lock")]), _vm._v("Locked COGS\n                    ")], 1) : _vm._e(), _vm._v(" "), (!_vm.isAdmin && _vm.disableLockedCOGS) ? _c('v-btn', {
    staticClass: "pairing-toolbar-btn",
    attrs: {
      "small": "",
      "color": "secondary"
    },
    on: {
      "click": function($event) {
        return _vm.openLockedCOGSDialog(_vm.campaign)
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("mdi-lock-open")]), _vm._v(" Request Unlock\n                    ")], 1) : _vm._e(), _vm._v(" "), (_vm.isAdmin && _vm.disableLockedCOGS) ? _c('v-btn', {
    staticClass: "pairing-toolbar-btn",
    attrs: {
      "color": "secondary"
    },
    on: {
      "click": function($event) {
        return _vm.changeLock(_vm.campaign, false)
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("mdi-lock-open")]), _vm._v(" Unlock\n                    ")], 1) : _vm._e(), _vm._v(" "), (_vm.showLockBtn) ? _c('v-btn', {
    staticClass: "pairing-toolbar-btn",
    attrs: {
      "color": "secondary"
    },
    on: {
      "click": function($event) {
        return _vm.changeLock(_vm.campaign, true)
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("mdi-lock")]), _vm._v(" Lock\n                    ")], 1) : _vm._e(), _vm._v(" "), (_vm.items && _vm.items.length > 0) ? _c('download-excel', {
    staticClass: "download-excel-secondary pairing-toolbar-download",
    attrs: {
      "data": _vm.items,
      "fields": _vm.json_fields,
      "worksheet": "Predicted price",
      "name": "pairing.xls"
    }
  }, [_vm._v("Download Excel")]) : _vm._e(), _vm._v(" "), _c('v-menu', {
    attrs: {
      "offset-y": "",
      "left": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;
        var attrs = ref.attrs;

        return [_c('v-btn', _vm._g(_vm._b({
          staticClass: "pairing-toolbar-btn",
          attrs: {
            "small": "",
            "color": "secondary",
            "disabled": _vm.actionSelected.length === 0 || _vm.disableLockedCOGS
          }
        }, 'v-btn', attrs, false), on), [_c('v-icon', {
          attrs: {
            "small": "",
            "left": ""
          }
        }, [_vm._v("mdi-format-list-bulleted")]), _vm._v("\n                        Bulk Action\n                        "), (_vm.actionSelected.length) ? _c('span', {
          staticClass: "ml-1"
        }, [_vm._v("(" + _vm._s(_vm.actionSelected.length) + ")")]) : _vm._e(), _vm._v(" "), _c('v-icon', {
          attrs: {
            "small": "",
            "right": ""
          }
        }, [_vm._v("mdi-chevron-down")])], 1)]
      }
    }])
  }, [_vm._v(" "), _c('v-list', {
    staticClass: "pairing-bulk-action-menu",
    attrs: {
      "dense": ""
    }
  }, [_c('v-list-item', {
    on: {
      "click": _vm.confirmDelete
    }
  }, [_c('v-list-item-icon', [_c('v-icon', {
    attrs: {
      "color": "error",
      "small": ""
    }
  }, [_vm._v("mdi-delete")])], 1), _vm._v(" "), _c('v-list-item-title', [_vm._v("Delete")])], 1), _vm._v(" "), _c('v-list-item', {
    on: {
      "click": function($event) {
        return _vm.changeBulkPairingStatus(_vm.pairingStatus.ACCEPTED.value)
      }
    }
  }, [_c('v-list-item-icon', [_c('v-icon', {
    attrs: {
      "color": "secondary",
      "small": ""
    }
  }, [_vm._v("mdi-check-circle")])], 1), _vm._v(" "), _c('v-list-item-title', [_vm._v("Accept")])], 1), _vm._v(" "), _c('v-list-item', {
    on: {
      "click": function($event) {
        return _vm.changeBulkPairingStatus(_vm.pairingStatus.NOT_ACCEPTED.value)
      }
    }
  }, [_c('v-list-item-icon', [_c('v-icon', {
    attrs: {
      "color": "error",
      "small": ""
    }
  }, [_vm._v("mdi-close-circle")])], 1), _vm._v(" "), _c('v-list-item-title', [_vm._v("Not Accept")])], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-list-item', {
    on: {
      "click": function($event) {
        return _vm.openDeliverableUpdateDialog()
      }
    }
  }, [_c('v-list-item-icon', [_c('v-icon', {
    attrs: {
      "color": "secondary",
      "small": ""
    }
  }, [_vm._v("mdi-pencil-box-multiple")])], 1), _vm._v(" "), _c('v-list-item-title', [_vm._v("Update Deliverables")])], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-list-item', {
    on: {
      "click": function($event) {
        return _vm.moveOption(0)
      }
    }
  }, [_c('v-list-item-icon', [_c('v-icon', {
    attrs: {
      "color": "secondary",
      "small": ""
    }
  }, [_vm._v("mdi-arrow-left-bold-circle")])], 1), _vm._v(" "), _c('v-list-item-title', [_vm._v("Move to Option A")])], 1), _vm._v(" "), _c('v-list-item', {
    on: {
      "click": function($event) {
        return _vm.moveOption(1)
      }
    }
  }, [_c('v-list-item-icon', [_c('v-icon', {
    attrs: {
      "color": "secondary",
      "small": ""
    }
  }, [_vm._v("mdi-arrow-right-bold-circle")])], 1), _vm._v(" "), _c('v-list-item-title', [_vm._v("Move to Option B")])], 1), _vm._v(" "), _c('v-list-item', {
    on: {
      "click": function($event) {
        return _vm.moveAllOption(0)
      }
    }
  }, [_c('v-list-item-icon', [_c('v-icon', {
    attrs: {
      "color": "secondary",
      "small": ""
    }
  }, [_vm._v("mdi-arrow-collapse-left")])], 1), _vm._v(" "), _c('v-list-item-title', [_vm._v("Move All to Option A")])], 1), _vm._v(" "), _c('v-list-item', {
    on: {
      "click": function($event) {
        return _vm.moveAllOption(1)
      }
    }
  }, [_c('v-list-item-icon', [_c('v-icon', {
    attrs: {
      "color": "secondary",
      "small": ""
    }
  }, [_vm._v("mdi-arrow-collapse-right")])], 1), _vm._v(" "), _c('v-list-item-title', [_vm._v("Move All to Option B")])], 1)], 1)], 1), _vm._v(" "), (!_vm.disableSaveLineUp) ? _c('v-btn', {
    staticClass: "pairing-toolbar-btn",
    attrs: {
      "color": "secondary",
      "small": ""
    },
    on: {
      "click": _vm.saveLineUp
    }
  }, [_vm._v("Save LineUp")]) : _vm._e()], 1)]), _vm._v(" "), (!_vm.disableSaveEdit) ? _c('v-col', {
    staticClass: "pairing-search-controls",
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "5",
      "lg": "5"
    }
  }, [(!_vm.disableSaveEdit) ? _c('div', {
    staticClass: "pairing-edit-actions"
  }, [_c('v-btn', {
    staticClass: "secondary--text",
    attrs: {
      "small": ""
    },
    on: {
      "click": _vm.cancelEdit
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "secondary",
      "small": ""
    },
    on: {
      "click": _vm.saveEditingData
    }
  }, [_vm._v("Save Changes")])], 1) : _vm._e()]) : _vm._e()], 1), _vm._v(" "), _c('v-row', {
    staticClass: "mt-0 pairing-filter-row"
  }, [_c('v-col', {
    staticClass: "mt-3",
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "12",
      "lg": "12"
    }
  }, [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "8",
      "lg": "8"
    }
  }, [_c('v-col', {
    staticStyle: {
      "max-width": "70px"
    },
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "1",
      "lg": "1",
      "align": "right"
    }
  }, [_c('label', {
    staticStyle: {
      "padding-top": "10px"
    }
  }, [_vm._v("\n                          Filters:\n                        ")])]), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "2",
      "lg": "2"
    }
  }, [_c('v-select', {
    attrs: {
      "items": _vm.filterPairingStatusOptions,
      "item-value": "status",
      "item-text": "display",
      "label": "Pairing Status",
      "dense": "",
      "solo": "",
      "attach": ""
    },
    on: {
      "change": _vm.pairingStatusOnChangeHandler
    },
    model: {
      value: (_vm.searchPairingStatus),
      callback: function($$v) {
        _vm.searchPairingStatus = $$v
      },
      expression: "searchPairingStatus"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "2",
      "lg": "2"
    }
  }, [_c('v-select', {
    attrs: {
      "items": _vm.genderItems,
      "label": "Gender",
      "dense": "",
      "solo": "",
      "attach": ""
    },
    on: {
      "change": _vm.genderOnChangeHandler
    },
    model: {
      value: (_vm.searchGender),
      callback: function($$v) {
        _vm.searchGender = $$v
      },
      expression: "searchGender"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "1",
      "lg": "1"
    }
  }, [_c('v-select', {
    attrs: {
      "items": _vm.ageItems,
      "label": "Age Group",
      "dense": "",
      "solo": "",
      "attach": ""
    },
    on: {
      "change": _vm.ageOnChangeHandler
    },
    model: {
      value: (_vm.searchAge),
      callback: function($$v) {
        _vm.searchAge = $$v
      },
      expression: "searchAge"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "2",
      "lg": "2"
    }
  }, [_c('v-select', {
    attrs: {
      "items": _vm.locationItems,
      "label": "Location",
      "dense": "",
      "solo": "",
      "attach": ""
    },
    on: {
      "change": _vm.countryOnChangeHandler
    },
    model: {
      value: (_vm.searchLocation),
      callback: function($$v) {
        _vm.searchLocation = $$v
      },
      expression: "searchLocation"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "2",
      "lg": "2"
    }
  }, [_c('v-select', {
    attrs: {
      "items": _vm.audCrediblityFilters,
      "item-text": "name",
      "label": "Audience Cred.",
      "dense": "",
      "solo": "",
      "attach": ""
    },
    on: {
      "change": _vm.pairingStatusOnChangeHandler
    },
    model: {
      value: (_vm.searchAudCrediblity),
      callback: function($$v) {
        _vm.searchAudCrediblity = $$v
      },
      expression: "searchAudCrediblity"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticStyle: {
      "max-width": "92px"
    },
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "1",
      "lg": "1"
    }
  }, [_c('v-btn', {
    attrs: {
      "color": "secondary"
    },
    on: {
      "click": _vm.clearFilter
    }
  }, [_vm._v("Clear")])], 1)], 1), _vm._v(" "), (this.campaign.pairingDisplayStatus) ? _c('v-col', {
    staticClass: "pairing-table-tools",
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "4",
      "lg": "4"
    }
  }, [_c('v-text-field', {
    staticClass: "pairing-table-search",
    attrs: {
      "append-icon": "mdi-magnify",
      "label": "Search",
      "single-line": "",
      "hide-details": ""
    },
    model: {
      value: (_vm.searchFilter),
      callback: function($$v) {
        _vm.searchFilter = $$v
      },
      expression: "searchFilter"
    }
  }), _vm._v(" "), _c('v-menu', {
    staticClass: "menu-pairing",
    staticStyle: {
      "max-height": "500px",
      "min-height": "500px"
    },
    attrs: {
      "close-on-content-click": false,
      "bottom": "",
      "left": "",
      "max-height": "500px"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;
        var attrs = ref.attrs;

        return [_c('v-btn', _vm._g(_vm._b({
          staticClass: "mt-3",
          attrs: {
            "icon": "",
            "color": "secondary"
          }
        }, 'v-btn', attrs, false), on), [_c('v-icon', [_vm._v("mdi-dots-vertical")])], 1)]
      }
    }], null, false, 1822390752)
  }, [_vm._v(" "), _c('v-list', _vm._l((_vm.showHideFields), function(field, index) {
    return _c('v-list-item', {
      key: index
    }, [_c('v-checkbox', {
      attrs: {
        "label": field.label,
        "color": "secondary",
        "true-value": true,
        "false-value": false,
        "hide-details": ""
      },
      on: {
        "change": _vm.updatePairingDisplayStatus
      },
      model: {
        value: (_vm.campaign.pairingDisplayStatus[field.name]),
        callback: function($$v) {
          _vm.$set(_vm.campaign.pairingDisplayStatus, field.name, $$v)
        },
        expression: "campaign.pairingDisplayStatus[field.name]"
      }
    })], 1)
  }), 1)], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "mt-3",
    attrs: {
      "icon": "",
      "color": "secondary",
      "title": _vm.showFrozenPairingColumns ? 'Hide frozen columns' : 'Show frozen columns',
      "aria-label": _vm.showFrozenPairingColumns ? 'Hide frozen columns' : 'Show frozen columns',
      "aria-pressed": String(_vm.showFrozenPairingColumns)
    },
    on: {
      "click": function($event) {
        _vm.showFrozenPairingColumns = !_vm.showFrozenPairingColumns
      }
    }
  }, [_c('v-icon', [_vm._v(_vm._s(_vm.showFrozenPairingColumns ? 'mdi-eye-off-outline' : 'mdi-eye-outline'))])], 1)], 1) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-data-table', {
    staticClass: "elevation-1 page__table pairing-freeze-table",
    class: {
      'pairing-freeze-active': _vm.showFrozenPairingColumns && _vm.displayFields('AIPayout') && _vm.displayFields('payout') && _vm.displayFields('pairingStatus')
    },
    attrs: {
      "headers": _vm.filteredHeaders,
      "items": _vm.items,
      "item-key": "dataTableKey",
      "search": _vm.searchFilter,
      "items-per-page": 20,
      "no-data-text": 'Empty list',
      "show-select": "",
      "single-select": false,
      "mobile-breakpoint": 0
    },
    on: {
      "update:page": _vm.updatePagination,
      "toggle-select-all": _vm.selectAllPairings
    },
    scopedSlots: _vm._u([{
      key: "body",
      fn: function(props) {
        return [_c('draggable', {
          attrs: {
            "list": props.items,
            "tag": "tbody"
          },
          on: {
            "update": function($event) {
              return _vm.handleTableUpdate(props.items)
            }
          }
        }, _vm._l((props.items), function(item, parentIndex) {
          return _c('tr', {
            key: item.instagram,
            class: {
              'danger': (!item.success || item.eliminationStatus === _vm.eliminationStatus.ELIMINATED) && !item.isLoading
            }
          }, [_c('td', {
            staticStyle: {
              "min-width": "100px",
              "padding": "0 14px!important"
            }
          }, [_c('v-icon', {
            staticClass: "move-cursor",
            attrs: {
              "small": ""
            }
          }, [_vm._v("\n                              mdi-arrow-all\n                            ")]), _vm._v(" "), (item.isLoading) ? _c('v-progress-circular', {
            attrs: {
              "width": 2,
              "color": "green",
              "indeterminate": ""
            }
          }) : _vm._e(), _vm._v(" "), _c('v-checkbox', {
            staticClass: "multi-select-checkbox",
            attrs: {
              "label": "",
              "color": "grey darken-2",
              "disabled": item.payoutStatus == _vm.payoutStatus.CONFIRMED
            },
            on: {
              "change": _vm.actionSelectChange
            },
            model: {
              value: (item.isDelete),
              callback: function($$v) {
                _vm.$set(item, "isDelete", $$v)
              },
              expression: "item.isDelete"
            }
          }), _vm._v(" "), (item.platform !== 'others') ? _c('v-tooltip', {
            attrs: {
              "bottom": ""
            },
            scopedSlots: _vm._u([{
              key: "activator",
              fn: function(ref) {
                var on = ref.on;

                return [_c('v-btn', _vm._g({
                  staticClass: "btn-reload",
                  attrs: {
                    "text": "",
                    "x-small": "",
                    "color": "secondary"
                  },
                  on: {
                    "click": function($event) {
                      return _vm.executeMethod('refresh', item)
                    }
                  }
                }, on), [_c('v-icon', {
                  attrs: {
                    "small": ""
                  }
                }, [_vm._v("\n                                    mdi-reload\n                                  ")])], 1)]
              }
            }], null, true)
          }, [_vm._v(" "), _c('span', [_vm._v("Click to refresh data")])]) : _vm._e()], 1), _vm._v(" "), (_vm.displayFields('lastReportDate')) ? _c('td', {
            staticStyle: {
              "min-width": "150px",
              "max-width": "150px"
            },
            attrs: {
              "align": "center"
            }
          }, [(item.lastReportDate) ? _c('span', [_vm._v(_vm._s(_vm.utilsFunc.formatCustomDate(item.lastReportDate, 'DD/MM/YYYY')))]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.displayFields('influencer')) ? _c('td', {
            staticStyle: {
              "min-width": "200px",
              "max-width": "200px"
            },
            attrs: {
              "align": "left"
            }
          }, [_c('social-handle', {
            attrs: {
              "divClassName": "d-inline",
              "isTikTok": item.platform === 'tiktok',
              "isInstagram": item.platform === 'instagram',
              "isFacebook": item.platform === 'facebook',
              "isLinkedIn": item.platform === 'linkedin',
              "isTwitter": item.platform === 'twitter',
              "isYoutube": item.platform === 'youtube',
              "isXiaohongshu": item.platform === 'xiaohongshu',
              "isOthers": item.platform === 'others',
              "tiktokHandle": item.userHandle,
              "instagramHandle": item.userHandle,
              "facebookHandle": item.userHandle,
              "linkedinHandle": item.userHandle,
              "twitterHandle": item.userHandle,
              "youtubeHandle": item.userHandle,
              "xiaohongshuHandle": item.xhsID,
              "xiaohongshuFullName": item.fullName,
              "youtubeURL": item.url,
              "otherHandle": item.userHandle
            }
          }), _vm._v(" "), (item.multipleInfs && item.multipleInfs.length > 1) ? _c('v-menu', {
            staticStyle: {
              "max-height": "500px"
            },
            attrs: {
              "bottom": "",
              "origin": "center center",
              "transition": "scale-transition"
            },
            scopedSlots: _vm._u([{
              key: "activator",
              fn: function(ref) {
                var on = ref.on;
                var attrs = ref.attrs;

                return [_c('v-btn', _vm._g(_vm._b({
                  staticStyle: {
                    "min-width": "0",
                    "padding": "0",
                    "margin-left": "-9px",
                    "margin-top": "-3px"
                  },
                  attrs: {
                    "text": "",
                    "color": "secondary"
                  }
                }, 'v-btn', attrs, false), on), [_c('v-tooltip', {
                  attrs: {
                    "bottom": ""
                  },
                  scopedSlots: _vm._u([{
                    key: "activator",
                    fn: function(ref) {
                      var on = ref.on;

                      return [_c('v-icon', _vm._g({
                        staticClass: "ml-2",
                        attrs: {
                          "color": "secondary",
                          "small": ""
                        }
                      }, on), [_vm._v("mdi-chevron-down-circle")])]
                    }
                  }], null, true)
                }, [_vm._v(" "), _c('span', [_vm._v("Multiple Accounts detected")])])], 1)]
              }
            }], null, true)
          }, [_vm._v(" "), _c('v-list', _vm._l((item.multipleInfs), function(obj, i) {
            return _c('v-list-item', {
              key: i,
              attrs: {
                "link": ""
              },
              on: {
                "click": function($event) {
                  return _vm.changePlatform(item.userHandle, obj.handle, obj.platform, item.pairingID)
                }
              }
            }, [_c('v-list-item-title', [(obj.xhs) ? _c('a', [_c('img', {
              staticStyle: {
                "filter": "invert(27%) sepia(87%) saturate(4714%) hue-rotate(340deg) brightness(103%) contrast(103%) !important"
              },
              attrs: {
                "src": "/static/img/xhs-black.png",
                "width": "20px"
              }
            }), _vm._v(" @" + _vm._s(obj.handle))]) : (obj.facebook) ? _c('a', [_c('v-icon', {
              staticStyle: {
                "color": "#1877F2 !important"
              },
              attrs: {
                "small": ""
              }
            }, [_vm._v("mdi-facebook")]), _vm._v(" @" + _vm._s(obj.handle))], 1) : (obj.linkedin) ? _c('a', [_c('v-icon', {
              staticStyle: {
                "color": "#0A66C2 !important"
              },
              attrs: {
                "small": ""
              }
            }, [_vm._v("mdi-linkedin")]), _vm._v(" @" + _vm._s(obj.handle))], 1) : (obj.twitter) ? _c('a', [_c('img', {
              attrs: {
                "src": "/static/img/x-logo.svg",
                "width": "15px",
                "alt": "X (Twitter)"
              }
            }), _vm._v(" @" + _vm._s(obj.handle))]) : (obj.tiktok) ? _c('a', [_c('img', {
              attrs: {
                "src": "/static/img/tiktok-32.png",
                "width": "20px"
              }
            }), _vm._v(" @" + _vm._s(obj.handle))]) : (obj.youtube) ? _c('a', [_c('v-icon', {
              staticStyle: {
                "color": "#FF0000 !important"
              },
              attrs: {
                "small": ""
              }
            }, [_vm._v("mdi-youtube")]), _vm._v(" @" + _vm._s(obj.handle))], 1) : _c('a', [_c('v-icon', {
              staticStyle: {
                "color": "#E1306C !important"
              },
              attrs: {
                "small": ""
              }
            }, [_vm._v("mdi-instagram")]), _vm._v(" @" + _vm._s(obj.handle))], 1)])], 1)
          }), 1)], 1) : _vm._e(), _vm._v(" "), (!item.isLoading && item.influencerID && item.isPlatformConnected !== false) ? _c('v-tooltip', {
            attrs: {
              "bottom": ""
            },
            scopedSlots: _vm._u([{
              key: "activator",
              fn: function(ref) {
                var on = ref.on;

                return [_c('v-icon', _vm._g({
                  attrs: {
                    "color": "green"
                  },
                  on: {
                    "click": true
                  }
                }, on), [_vm._v("done")])]
              }
            }], null, true)
          }, [_vm._v(" "), _c('span', [_vm._v("Registered on IMS")])]) : _vm._e(), _vm._v(" "), (!item.isLoading && item.influencerID && item.isPlatformConnected === false) ? _c('v-tooltip', {
            attrs: {
              "bottom": ""
            },
            scopedSlots: _vm._u([{
              key: "activator",
              fn: function(ref) {
                var on = ref.on;

                return [_c('v-icon', _vm._g({
                  attrs: {
                    "color": "red"
                  },
                  on: {
                    "click": true
                  }
                }, on), [_vm._v("cancel")])]
              }
            }], null, true)
          }, [_vm._v(" "), _c('span', [_vm._v("Platform handle disconnected")])]) : _vm._e(), _vm._v(" "), (!item.isLoading && !item.influencerID) ? _c('v-tooltip', {
            attrs: {
              "bottom": ""
            },
            scopedSlots: _vm._u([{
              key: "activator",
              fn: function(ref) {
                var on = ref.on;

                return [_c('v-icon', _vm._g({
                  attrs: {
                    "color": "red"
                  },
                  on: {
                    "click": true
                  }
                }, on), [_vm._v("cancel")])]
              }
            }], null, true)
          }, [_vm._v(" "), _c('span', [_vm._v("Not in IMS")])]) : _vm._e(), _vm._v(" "), (item.socialDataErrMessage) ? _c('p', {
            staticClass: "text-danger mb-0"
          }, [_vm._v("(" + _vm._s(item.socialDataErrMessage) + ")")]) : _vm._e(), _vm._v(" "), (_vm.checkReportDate(item.lastReportDate)) ? _c('p', {
            staticClass: "caption caption-text ma-0",
            staticStyle: {
              "font-size": "12px"
            }
          }, [_vm._v("(Last date is over 6 months. Please refresh data)")]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (item.platformNameEdit === false && _vm.displayFields('platformName')) ? _c('td', {
            staticStyle: {
              "min-width": "200px"
            },
            attrs: {
              "align": "center"
            },
            on: {
              "click": function($event) {
                return _vm.openEditItem(item.pairingID, 'platformName')
              }
            }
          }, [_c('p', [_vm._v(_vm._s(_vm._f("platformDisplayName")(item.platformName)))]), _vm._v(" "), (!item.platformNameEdit && item.platform === 'others') ? _c('v-btn', {
            attrs: {
              "icon": "",
              "small": "",
              "color": "secondary",
              "title": "Edit Platform"
            },
            on: {
              "click": function($event) {
                return _vm.changePairingColEdit('platformNameEdit', item, true)
              }
            }
          }, [_c('v-icon', {
            attrs: {
              "small": ""
            }
          }, [_vm._v("mdi-pencil")])], 1) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (item.platformNameEdit === true) ? _c('td', {
            staticClass: "editing",
            attrs: {
              "align": "center"
            }
          }, [_c('v-text-field', {
            staticClass: "ma-3",
            staticStyle: {
              "width": "100%"
            },
            attrs: {
              "hide-details": "",
              "dense": "",
              "outlined": ""
            },
            model: {
              value: (item.platformName),
              callback: function($$v) {
                _vm.$set(item, "platformName", $$v)
              },
              expression: "item.platformName"
            }
          }), _vm._v(" "), _c('v-btn', {
            staticStyle: {
              "margin-top": "7px"
            },
            attrs: {
              "color": "secondary",
              "x-small": ""
            },
            on: {
              "click": function($event) {
                return _vm.updatePairingCol(item, 'platformName')
              }
            }
          }, [_c('v-icon', {
            staticClass: "cursor-pointer",
            attrs: {
              "title": "Close",
              "x-small": ""
            }
          }, [_vm._v("check")])], 1), _vm._v(" "), _c('v-btn', {
            staticStyle: {
              "margin-top": "7px"
            },
            attrs: {
              "color": "error",
              "x-small": ""
            },
            on: {
              "click": function($event) {
                return _vm.changePairingColEdit('platformNameEdit', item, false)
              }
            }
          }, [_c('v-icon', {
            staticClass: "cursor-pointer",
            attrs: {
              "title": "Close",
              "x-small": ""
            }
          }, [_vm._v("close")])], 1)], 1) : _vm._e(), _vm._v(" "), (item.remarkEdit === false && _vm.displayFields('remark')) ? _c('td', {
            staticStyle: {
              "min-width": "200px"
            },
            attrs: {
              "align": "center"
            },
            on: {
              "click": function($event) {
                return _vm.openEditItem(item.pairingID, 'remark')
              }
            }
          }, [_c('v-tooltip', {
            attrs: {
              "bottom": "",
              "max-width": "300px"
            },
            scopedSlots: _vm._u([{
              key: "activator",
              fn: function(ref) {
                var on = ref.on;

                return [_c('div', _vm._g({}, on), [_c('p', {
                  staticClass: "remark-text"
                }, [_vm._v(_vm._s(item.remarks || '-'))])])]
              }
            }], null, true)
          }, [_vm._v(" "), _c('span', {
            domProps: {
              "innerHTML": _vm._s(_vm.renderRemark(item.remarks))
            }
          })])], 1) : _vm._e(), _vm._v(" "), (item.remarkEdit === true) ? _c('td', {
            staticClass: "editing",
            attrs: {
              "align": "center"
            }
          }, [_c('v-textarea', {
            staticClass: "ma-3",
            staticStyle: {
              "width": "100%"
            },
            attrs: {
              "hide-details": "",
              "dense": "",
              "outlined": ""
            },
            model: {
              value: (item.remarks),
              callback: function($$v) {
                _vm.$set(item, "remarks", $$v)
              },
              expression: "item.remarks"
            }
          })], 1) : _vm._e(), _vm._v(" "), (item.contentFeatureEdit === false && _vm.displayFields('contentFeature')) ? _c('td', {
            staticStyle: {
              "min-width": "200px"
            },
            attrs: {
              "align": "center"
            },
            on: {
              "click": function($event) {
                return _vm.openEditItem(item.pairingID, 'contentFeature')
              }
            }
          }, [_c('v-tooltip', {
            attrs: {
              "bottom": "",
              "max-width": "300px"
            },
            scopedSlots: _vm._u([{
              key: "activator",
              fn: function(ref) {
                var on = ref.on;

                return [_c('div', _vm._g({}, on), [_c('p', {
                  staticClass: "remark-text"
                }, [_vm._v(_vm._s(item.contentFeature || '-'))])])]
              }
            }], null, true)
          }, [_vm._v(" "), _c('span', {
            domProps: {
              "innerHTML": _vm._s(_vm.renderRemark(item.contentFeature))
            }
          })])], 1) : _vm._e(), _vm._v(" "), (item.contentFeatureEdit === true) ? _c('td', {
            staticClass: "editing",
            attrs: {
              "align": "center"
            }
          }, [_c('v-textarea', {
            staticClass: "ma-3",
            staticStyle: {
              "width": "100%"
            },
            attrs: {
              "hide-details": "",
              "dense": "",
              "outlined": ""
            },
            model: {
              value: (item.contentFeature),
              callback: function($$v) {
                _vm.$set(item, "contentFeature", $$v)
              },
              expression: "item.contentFeature"
            }
          })], 1) : _vm._e(), _vm._v(" "), (_vm.displayFields('gender')) ? _c('td', {
            attrs: {
              "align": "center"
            }
          }, [(item.genderEdit) ? _c('div', {
            staticClass: "d-flex flex-row pa-2"
          }, [_c('v-select', {
            staticStyle: {
              "min-width": "100px",
              "max-width": "100px"
            },
            attrs: {
              "items": _vm.genders,
              "dense": "",
              "hide-details": ""
            },
            model: {
              value: (item.gender),
              callback: function($$v) {
                _vm.$set(item, "gender", $$v)
              },
              expression: "item.gender"
            }
          }), _vm._v(" "), _c('v-btn', {
            staticStyle: {
              "margin-top": "7px"
            },
            attrs: {
              "color": "secondary",
              "x-small": ""
            },
            on: {
              "click": function($event) {
                return _vm.updatePairingCol(item, 'gender')
              }
            }
          }, [_c('v-icon', {
            staticClass: "cursor-pointer",
            attrs: {
              "title": "Close",
              "x-small": ""
            }
          }, [_vm._v("check")])], 1), _vm._v(" "), _c('v-btn', {
            staticStyle: {
              "margin-top": "7px"
            },
            attrs: {
              "color": "error",
              "x-small": ""
            },
            on: {
              "click": function($event) {
                return _vm.changePairingColEdit('genderEdit', item, false)
              }
            }
          }, [_c('v-icon', {
            staticClass: "cursor-pointer",
            attrs: {
              "title": "Close",
              "x-small": ""
            }
          }, [_vm._v("close")])], 1)], 1) : _vm._e(), _vm._v(" "), (!item.genderEdit) ? _c('div', [(!item.genderEdit) ? _c('v-chip', {
            staticClass: "ma-2",
            staticStyle: {
              "text-transform": "capitalize"
            },
            attrs: {
              "color": "#ffffff",
              "x-small": "",
              "text-color": "black"
            }
          }, [_vm._v(_vm._s(item.gender || '-'))]) : _vm._e(), _vm._v(" "), (!item.genderEdit) ? _c('v-btn', {
            attrs: {
              "icon": "",
              "small": "",
              "color": "secondary",
              "title": "Edit Gender"
            },
            on: {
              "click": function($event) {
                return _vm.changePairingColEdit('genderEdit', item, true)
              }
            }
          }, [_c('v-icon', {
            attrs: {
              "small": ""
            }
          }, [_vm._v("mdi-pencil")])], 1) : _vm._e()], 1) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.displayFields('ageGroup')) ? _c('td', {
            attrs: {
              "align": "center"
            }
          }, [(item.ageGroupEdit) ? _c('div', {
            staticClass: "d-flex flex-row pa-2"
          }, [_c('v-select', {
            staticStyle: {
              "min-width": "100px",
              "max-width": "100px"
            },
            attrs: {
              "items": _vm.ageGroups,
              "dense": "",
              "hide-details": ""
            },
            model: {
              value: (item.age_group),
              callback: function($$v) {
                _vm.$set(item, "age_group", $$v)
              },
              expression: "item.age_group"
            }
          }), _vm._v(" "), _c('v-btn', {
            staticStyle: {
              "margin-top": "7px"
            },
            attrs: {
              "color": "secondary",
              "x-small": ""
            },
            on: {
              "click": function($event) {
                return _vm.updatePairingCol(item, 'age_group')
              }
            }
          }, [_c('v-icon', {
            staticClass: "cursor-pointer",
            attrs: {
              "title": "Close",
              "x-small": ""
            }
          }, [_vm._v("check")])], 1), _vm._v(" "), _c('v-btn', {
            staticStyle: {
              "margin-top": "7px"
            },
            attrs: {
              "color": "error",
              "x-small": ""
            },
            on: {
              "click": function($event) {
                return _vm.changePairingColEdit('ageGroupEdit', item, false)
              }
            }
          }, [_c('v-icon', {
            staticClass: "cursor-pointer",
            attrs: {
              "title": "Close",
              "x-small": ""
            }
          }, [_vm._v("close")])], 1)], 1) : _vm._e(), _vm._v(" "), (!item.ageGroupEdit) ? _c('div', [_c('v-chip', {
            staticClass: "ma-2",
            staticStyle: {
              "text-transform": "capitalize"
            },
            attrs: {
              "color": "#ffffff",
              "x-small": "",
              "text-color": "black"
            }
          }, [_vm._v(_vm._s(item.age_group || '-'))]), _vm._v(" "), (!item.ageGroupEdit) ? _c('v-btn', {
            attrs: {
              "icon": "",
              "small": "",
              "color": "secondary",
              "title": "Edit Age Group"
            },
            on: {
              "click": function($event) {
                return _vm.changePairingColEdit('ageGroupEdit', item, true)
              }
            }
          }, [_c('v-icon', {
            attrs: {
              "small": ""
            }
          }, [_vm._v("mdi-pencil")])], 1) : _vm._e()], 1) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.displayFields('audAgeGroup')) ? _c('td', {
            attrs: {
              "align": "center"
            }
          }, [_c('div', [(item.audAgesEdit) ? _c('div', {
            staticClass: "d-flex flex-row"
          }, [_c('v-select', {
            staticStyle: {
              "min-width": "120px",
              "max-width": "320px"
            },
            attrs: {
              "items": _vm.ageGroups,
              "item-text": "code",
              "item-value": "code",
              "hide-details": "",
              "dense": "",
              "multiple": ""
            },
            on: {
              "change": function($event) {
                return _vm.checkSelectLimit(item, 'topAudAges')
              }
            },
            model: {
              value: (item.topAudAges),
              callback: function($$v) {
                _vm.$set(item, "topAudAges", $$v)
              },
              expression: "item.topAudAges"
            }
          }), _vm._v(" "), _c('v-btn', {
            staticStyle: {
              "margin-top": "7px"
            },
            attrs: {
              "color": "secondary",
              "x-small": ""
            },
            on: {
              "click": function($event) {
                return _vm.updatePairingCol(item, 'topAudAges')
              }
            }
          }, [_c('v-icon', {
            staticClass: "cursor-pointer",
            attrs: {
              "title": "Close",
              "x-small": ""
            }
          }, [_vm._v("check")])], 1), _vm._v(" "), _c('v-btn', {
            staticStyle: {
              "margin-top": "7px"
            },
            attrs: {
              "color": "error",
              "x-small": ""
            },
            on: {
              "click": function($event) {
                return _vm.changePairingColEdit('audAgesEdit', item, false)
              }
            }
          }, [_c('v-icon', {
            staticClass: "cursor-pointer",
            attrs: {
              "title": "Close",
              "x-small": ""
            }
          }, [_vm._v("close")])], 1)], 1) : _vm._e(), _vm._v(" "), ((!item.audAges || (Array.isArray(item.audAges) && item.audAges.length === 0)) && (!item.topAudAges || (Array.isArray(item.topAudAges) && item.topAudAges.length === 0))) ? _c('v-chip', {
            staticClass: "ma-2",
            staticStyle: {
              "text-transform": "capitalize"
            },
            attrs: {
              "color": "#ffffff",
              "x-small": "",
              "text-color": "black"
            }
          }, [_vm._v(_vm._s('-'))]) : _vm._e(), _vm._v(" "), (Array.isArray(item.audAges) && Array.isArray(item.topAudAges)) ? _c('div', [((item.audAges.length || item.topAudAges.length) && !item.audAgesEdit) ? _c('v-menu', {
            attrs: {
              "close-on-content-click": false,
              "top": "",
              "offset-x": ""
            },
            scopedSlots: _vm._u([{
              key: "activator",
              fn: function(ref) {
                var on = ref.on;
                var attrs = ref.attrs;

                return [_c('v-btn', _vm._g(_vm._b({
                  directives: [{
                    name: "show",
                    rawName: "v-show",
                    value: ((item.audAges.length || item.topAudAges.length) && !item.audAgesEdit),
                    expression: "(item.audAges.length || item.topAudAges.length) && !item.audAgesEdit"
                  }],
                  staticClass: "multi-select-more-btn ma-2",
                  attrs: {
                    "id": 'btnMore_' + parentIndex,
                    "x-small": "",
                    "text": "",
                    "color": "secondary"
                  }
                }, 'v-btn', attrs, false), on), [(item.topAudAges && item.topAudAges.length) ? _c('span', [_vm._v("\n                                        " + _vm._s(item.topAudAges ? item.topAudAges[0] : '-') + "\n                                      ")]) : _c('span', [_vm._v("\n                                        " + _vm._s(item.audAges.length ? item.audAges[0].code : '-') + "\n                                      ")])])]
              }
            }], null, true)
          }, [_vm._v(" "), _c('v-card', {
            staticStyle: {
              "text-align": "left"
            },
            attrs: {
              "max-width": "300"
            }
          }, [_c('v-card-text', [_c('div', [_vm._v("Aud. Age Group (Majority)")]), _vm._v(" "), (item.audAgesDisplay) ? _c('div', [_c('v-divider'), _vm._v(" "), _vm._l((item.audAgesDisplay), function(audAge, index) {
            return _c('div', {
              key: index,
              staticClass: "d-flex justify-space-between"
            }, [_c('v-chip', {
              staticClass: "ma-2",
              attrs: {
                "x-small": ""
              }
            }, [_vm._v(_vm._s(audAge.code))]), _vm._v(" "), (audAge.weight) ? _c('span', {
              staticClass: "more-percent"
            }, [_vm._v("(" + _vm._s((audAge.weight * 100).toFixed(2)) + "%)")]) : _vm._e()], 1)
          })], 2) : _vm._e(), _vm._v(" "), _c('v-divider'), _vm._v(" "), _vm._l((item.audAges), function(age, index) {
            return _c('div', {
              key: index,
              staticClass: "d-flex justify-space-between"
            }, [_c('v-chip', {
              staticClass: "ma-2",
              attrs: {
                "x-small": ""
              }
            }, [_vm._v(_vm._s(age.code))]), _vm._v(" "), _c('span', {
              staticClass: "more-percent"
            }, [_vm._v("(" + _vm._s((age.weight * 100).toFixed(2)) + "%)")])], 1)
          })], 2)], 1)], 1) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (!item.audAgesEdit) ? _c('div', [(!item.audAgesEdit) ? _c('v-btn', {
            attrs: {
              "icon": "",
              "small": "",
              "color": "secondary",
              "title": "Edit Aud. Age Group"
            },
            on: {
              "click": function($event) {
                return _vm.changePairingColEdit('audAgesEdit', item, true)
              }
            }
          }, [_c('v-icon', {
            attrs: {
              "small": ""
            }
          }, [_vm._v("mdi-pencil")])], 1) : _vm._e()], 1) : _vm._e()], 1)]) : _vm._e(), _vm._v(" "), (_vm.displayFields('country')) ? _c('td', {
            attrs: {
              "align": "center"
            }
          }, [(item.audCountryEdit) ? _c('div', {
            staticClass: "d-flex flex-row"
          }, [_c('v-select', {
            staticStyle: {
              "min-width": "120px",
              "max-width": "320px"
            },
            attrs: {
              "items": _vm.locationItems,
              "item-text": "name",
              "item-value": "name",
              "hide-details": "",
              "dense": "",
              "multiple": ""
            },
            on: {
              "change": function($event) {
                return _vm.checkSelectLimit(item, 'topCountries')
              }
            },
            model: {
              value: (item.topCountries),
              callback: function($$v) {
                _vm.$set(item, "topCountries", $$v)
              },
              expression: "item.topCountries"
            }
          }), _vm._v(" "), _c('v-btn', {
            staticStyle: {
              "margin-top": "7px"
            },
            attrs: {
              "color": "secondary",
              "x-small": ""
            },
            on: {
              "click": function($event) {
                return _vm.updatePairingCol(item, 'topCountries')
              }
            }
          }, [_c('v-icon', {
            staticClass: "cursor-pointer",
            attrs: {
              "title": "Close",
              "x-small": ""
            }
          }, [_vm._v("check")])], 1), _vm._v(" "), _c('v-btn', {
            staticStyle: {
              "margin-top": "7px"
            },
            attrs: {
              "color": "error",
              "x-small": ""
            },
            on: {
              "click": function($event) {
                return _vm.changePairingColEdit('audCountryEdit', item, false)
              }
            }
          }, [_c('v-icon', {
            staticClass: "cursor-pointer",
            attrs: {
              "title": "Close",
              "x-small": ""
            }
          }, [_vm._v("close")])], 1)], 1) : _vm._e(), _vm._v(" "), ((!item.countries || (Array.isArray(item.countries) && item.countries.length === 0)) && (!item.topCountries || (Array.isArray(item.topCountries) && item.topCountries.length === 0))) ? _c('v-chip', {
            staticClass: "ma-2",
            staticStyle: {
              "text-transform": "capitalize"
            },
            attrs: {
              "color": "#ffffff",
              "x-small": "",
              "text-color": "black"
            }
          }, [_vm._v(_vm._s('-'))]) : _vm._e(), _vm._v(" "), (Array.isArray(item.countries) && Array.isArray(item.topCountries)) ? _c('div', [_c('v-menu', {
            directives: [{
              name: "show",
              rawName: "v-show",
              value: ((item.countries.length || item.topCountries.length) && !item.audCountryEdit),
              expression: "(item.countries.length || item.topCountries.length) && !item.audCountryEdit"
            }],
            attrs: {
              "close-on-content-click": false,
              "top": "",
              "offset-x": ""
            },
            scopedSlots: _vm._u([{
              key: "activator",
              fn: function(ref) {
                var on = ref.on;
                var attrs = ref.attrs;

                return [_c('v-btn', _vm._g(_vm._b({
                  directives: [{
                    name: "show",
                    rawName: "v-show",
                    value: ((item.countries.length || item.topCountries.length) && !item.audCountryEdit),
                    expression: "(item.countries.length || item.topCountries.length) && !item.audCountryEdit"
                  }],
                  staticClass: "multi-select-more-btn ma-2",
                  attrs: {
                    "id": 'btnMore_' + parentIndex,
                    "x-small": "",
                    "text": "",
                    "color": "secondary"
                  }
                }, 'v-btn', attrs, false), on), [(item.topCountries && item.topCountries.length) ? _c('span', [_vm._v("\n                                      " + _vm._s(item.topCountries ? item.topCountries[0] : '-') + "\n                                    ")]) : _c('span', [_vm._v("\n                                      " + _vm._s(item.countries.length ? item.countries[0].name : '-') + "\n                                    ")])])]
              }
            }], null, true)
          }, [_vm._v(" "), _c('v-card', {
            staticStyle: {
              "text-align": "left"
            },
            attrs: {
              "max-width": "300"
            }
          }, [_c('v-card-text', [_c('div', [_vm._v("Aud. Country (Majority)")]), _vm._v(" "), (item.topCountryDisplay) ? _c('div', [_c('v-divider'), _vm._v(" "), _vm._l((item.topCountryDisplay), function(country, index) {
            return _c('div', {
              key: index,
              staticClass: "d-flex justify-space-between"
            }, [_c('v-chip', {
              staticClass: "ma-2",
              attrs: {
                "x-small": ""
              }
            }, [_vm._v(_vm._s(country.name))]), _vm._v(" "), (country.weight) ? _c('span', {
              staticClass: "more-percent"
            }, [_vm._v("(" + _vm._s((country.weight * 100).toFixed(2)) + "%)")]) : _vm._e()], 1)
          })], 2) : _vm._e(), _vm._v(" "), _c('v-divider'), _vm._v(" "), _vm._l((item.countries), function(country, index) {
            return _c('div', {
              key: index,
              staticClass: "d-flex justify-space-between"
            }, [_c('v-chip', {
              staticClass: "ma-2",
              attrs: {
                "x-small": ""
              }
            }, [_vm._v(_vm._s(country.name))]), _vm._v(" "), (country.weight) ? _c('span', {
              staticClass: "more-percent"
            }, [_vm._v("(" + _vm._s((country.weight * 100).toFixed(2)) + "%)")]) : _vm._e()], 1)
          })], 2)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (!item.audCountryEdit) ? _c('div', [(!item.audCountryEdit) ? _c('v-btn', {
            attrs: {
              "icon": "",
              "small": "",
              "color": "secondary",
              "title": "Edit Aud. Country"
            },
            on: {
              "click": function($event) {
                return _vm.changePairingColEdit('audCountryEdit', item, true)
              }
            }
          }, [_c('v-icon', {
            attrs: {
              "small": ""
            }
          }, [_vm._v("mdi-pencil")])], 1) : _vm._e()], 1) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.displayFields('followers')) ? _c('td', {
            attrs: {
              "align": "center"
            }
          }, [(item.followersEdit) ? _c('div', {
            staticClass: "d-flex flex-row pa-2"
          }, [_c('v-text-field', {
            staticClass: "ma-3",
            staticStyle: {
              "width": "100%",
              "min-width": "150px"
            },
            attrs: {
              "type": "number",
              "hide-details": "",
              "dense": "",
              "outlined": ""
            },
            model: {
              value: (item.followers),
              callback: function($$v) {
                _vm.$set(item, "followers", $$v)
              },
              expression: "item.followers"
            }
          }), _vm._v(" "), _c('div', {
            staticClass: "d-flex flex-row mt-2"
          }, [_c('v-btn', {
            staticStyle: {
              "margin-top": "7px"
            },
            attrs: {
              "color": "secondary",
              "x-small": ""
            },
            on: {
              "click": function($event) {
                return _vm.updatePairingCol(item, 'followers')
              }
            }
          }, [_c('v-icon', {
            staticClass: "cursor-pointer",
            attrs: {
              "title": "Close",
              "x-small": ""
            }
          }, [_vm._v("check")])], 1), _vm._v(" "), _c('v-btn', {
            staticStyle: {
              "margin-top": "7px"
            },
            attrs: {
              "color": "error",
              "x-small": ""
            },
            on: {
              "click": function($event) {
                return _vm.changePairingColEdit('followersEdit', item, false)
              }
            }
          }, [_c('v-icon', {
            staticClass: "cursor-pointer",
            attrs: {
              "title": "Close",
              "x-small": ""
            }
          }, [_vm._v("close")])], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (!item.followersEdit) ? _c('div', [_c('v-chip', {
            staticClass: "ma-2",
            attrs: {
              "color": "#CFD8DC",
              "x-small": "",
              "text-color": "black"
            }
          }, [_vm._v(_vm._s(item.followers ? _vm.formatNumber(item.followers) : '-'))]), _vm._v(" "), (!item.followersEdit && item.platform === 'others') ? _c('v-btn', {
            attrs: {
              "icon": "",
              "small": "",
              "color": "secondary",
              "title": "Edit Followers"
            },
            on: {
              "click": function($event) {
                return _vm.changePairingColEdit('followersEdit', item, true)
              }
            }
          }, [_c('v-icon', {
            attrs: {
              "small": ""
            }
          }, [_vm._v("mdi-pencil")])], 1) : _vm._e()], 1) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.displayFields('genderPercentage')) ? _c('td', {
            attrs: {
              "align": "center"
            }
          }, [_c('div', {
            staticStyle: {
              "width": "75px"
            }
          }, [(item.audience_genders && item.audience_genders.length > 0 && _vm.showPie) ? _c('PieChart', {
            attrs: {
              "name": ("genderPie" + parentIndex),
              "title": _vm.genderPie.title,
              "labels": _vm.genderPie.labels,
              "backgroundColors": _vm.genderPie.backgroundColors,
              "items": item.audience_genders,
              "options": _vm.genderPie.options,
              "width": _vm.genderPie.width,
              "height": _vm.genderPie.height
            }
          }) : _vm._e()], 1)]) : _vm._e(), _vm._v(" "), (_vm.displayFields('audienceCred')) ? _c('td', {
            attrs: {
              "align": "center"
            }
          }, [_c('v-chip', {
            staticClass: "ma-2",
            attrs: {
              "x-small": "",
              "color": item.audience_credibility_color,
              "text-color": "white"
            }
          }, [_vm._v(_vm._s(item.audience_credibility) + "%")]), _vm._v(" "), (item.message) ? _c('span', {
            staticClass: "text-danger"
          }, [_vm._v("(" + _vm._s(item.message) + ")")]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.displayFields('avgLikes')) ? _c('td', {
            attrs: {
              "align": "center"
            }
          }, [_c('v-chip', {
            staticClass: "ma-2",
            attrs: {
              "color": "#CFD8DC",
              "x-small": "",
              "text-color": "black"
            }
          }, [_vm._v(_vm._s(item.avg_likes ? _vm.formatNumber(item.avg_likes) : '-'))])], 1) : _vm._e(), _vm._v(" "), (_vm.displayFields('avgComments')) ? _c('td', {
            attrs: {
              "align": "center"
            }
          }, [_c('v-chip', {
            staticClass: "ma-2",
            attrs: {
              "color": "#CFD8DC",
              "x-small": "",
              "text-color": "black"
            }
          }, [_vm._v(_vm._s(item.avg_comments ? _vm.formatNumber(item.avg_comments) : '-'))])], 1) : _vm._e(), _vm._v(" "), (_vm.displayFields('avgReelsPlays')) ? _c('td', {
            attrs: {
              "align": "center"
            }
          }, [_c('v-chip', {
            staticClass: "ma-2",
            attrs: {
              "color": "#CFD8DC",
              "x-small": "",
              "text-color": "black"
            }
          }, [_vm._v(_vm._s(item.avg_reels_plays ? _vm.formatNumber(item.avg_reels_plays) : '-'))])], 1) : _vm._e(), _vm._v(" "), (_vm.displayFields('avgViews')) ? _c('td', {
            attrs: {
              "align": "center"
            }
          }, [_c('v-chip', {
            staticClass: "ma-2",
            attrs: {
              "color": "#CFD8DC",
              "x-small": "",
              "text-color": "black"
            }
          }, [_vm._v(_vm._s(item.avg_views ? _vm.formatNumber(item.avg_views) : '-'))])], 1) : _vm._e(), _vm._v(" "), (_vm.displayFields('avgSaves')) ? _c('td', {
            attrs: {
              "align": "center"
            }
          }, [_c('v-chip', {
            staticClass: "ma-2",
            attrs: {
              "color": "#CFD8DC",
              "x-small": "",
              "text-color": "black"
            }
          }, [_vm._v(_vm._s(item.avg_saves ? _vm.formatNumber(item.avg_saves) : '-'))])], 1) : _vm._e(), _vm._v(" "), (_vm.displayFields('avgShares')) ? _c('td', {
            attrs: {
              "align": "center"
            }
          }, [_c('v-chip', {
            staticClass: "ma-2",
            attrs: {
              "color": "#CFD8DC",
              "x-small": "",
              "text-color": "black"
            }
          }, [_vm._v(_vm._s(item.avg_shares ? _vm.formatNumber(item.avg_shares) : '-'))])], 1) : _vm._e(), _vm._v(" "), (_vm.displayFields('medianEngagementRate')) ? _c('td', {
            attrs: {
              "align": "center"
            }
          }, [_c('v-chip', {
            staticClass: "ma-2",
            attrs: {
              "color": "#CFD8DC",
              "x-small": "",
              "text-color": "black"
            }
          }, [_vm._v(_vm._s(item.median_engagement_rate ? ((item.median_engagement_rate) + "%") : '-'))])], 1) : _vm._e(), _vm._v(" "), (_vm.displayFields('infInterests')) ? _c('td', {
            attrs: {
              "align": "center"
            }
          }, [(!item.infInterests || item.infInterests.length === 0) ? _c('v-chip', {
            staticClass: "ma-2",
            staticStyle: {
              "text-transform": "capitalize"
            },
            attrs: {
              "color": "#ffffff",
              "x-small": "",
              "text-color": "black"
            }
          }, [_vm._v(_vm._s('-'))]) : _vm._l((item.infInterests), function(interest, index) {
            return _c('v-chip', {
              directives: [{
                name: "show",
                rawName: "v-show",
                value: (index === 0),
                expression: "index === 0"
              }],
              key: index,
              staticClass: "ma-2",
              attrs: {
                "x-small": ""
              }
            }, [_vm._v(_vm._s(interest.name))])
          }), _vm._v(" "), _c('v-menu', {
            directives: [{
              name: "show",
              rawName: "v-show",
              value: (item.infInterests),
              expression: "item.infInterests"
            }],
            attrs: {
              "close-on-content-click": false,
              "top": "",
              "offset-x": ""
            },
            scopedSlots: _vm._u([{
              key: "activator",
              fn: function(ref) {
                var on = ref.on;
                var attrs = ref.attrs;

                return [_c('v-btn', _vm._g(_vm._b({
                  directives: [{
                    name: "show",
                    rawName: "v-show",
                    value: (item.infInterests && item.infInterests.length > 0),
                    expression: "item.infInterests && item.infInterests.length > 0"
                  }],
                  attrs: {
                    "id": 'btnMore_' + item.id,
                    "color": "secondary",
                    "x-small": "",
                    "text": ""
                  }
                }, 'v-btn', attrs, false), on), [_vm._v("\n                                  More...\n                                ")])]
              }
            }], null, true)
          }, [_vm._v(" "), _c('v-card', {
            staticStyle: {
              "text-align": "left"
            },
            attrs: {
              "max-width": "300"
            }
          }, [_c('v-card-text', [_c('div', [_vm._v("Influencer Interests")]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _vm._l((item.infInterests), function(interest, index) {
            return _c('v-chip', {
              directives: [{
                name: "show",
                rawName: "v-show",
                value: (index !== 0),
                expression: "index !== 0"
              }],
              key: index,
              staticClass: "ma-2",
              attrs: {
                "small": ""
              }
            }, [_vm._v(_vm._s(interest.name))])
          })], 2)], 1)], 1)], 2) : _vm._e(), _vm._v(" "), (_vm.displayFields('interests')) ? _c('td', {
            attrs: {
              "align": "center"
            }
          }, [(!item.audience_interests || item.audience_interests.length === 0) ? _c('v-chip', {
            staticClass: "ma-2",
            staticStyle: {
              "text-transform": "capitalize"
            },
            attrs: {
              "color": "#ffffff",
              "x-small": "",
              "text-color": "black"
            }
          }, [_vm._v(_vm._s('-'))]) : _vm._l((item.audience_interests), function(interest, index) {
            return _c('v-chip', {
              directives: [{
                name: "show",
                rawName: "v-show",
                value: (index === 0),
                expression: "index === 0"
              }],
              key: index,
              staticClass: "ma-2",
              attrs: {
                "x-small": ""
              }
            }, [_vm._v(_vm._s(interest.name))])
          }), _vm._v(" "), _c('v-menu', {
            directives: [{
              name: "show",
              rawName: "v-show",
              value: (item.audience_interests),
              expression: "item.audience_interests"
            }],
            attrs: {
              "close-on-content-click": false,
              "top": "",
              "offset-x": ""
            },
            scopedSlots: _vm._u([{
              key: "activator",
              fn: function(ref) {
                var on = ref.on;
                var attrs = ref.attrs;

                return [_c('v-btn', _vm._g(_vm._b({
                  directives: [{
                    name: "show",
                    rawName: "v-show",
                    value: (item.audience_interests && item.audience_interests.length > 0),
                    expression: "item.audience_interests && item.audience_interests.length > 0"
                  }],
                  attrs: {
                    "id": 'btnMore_' + parentIndex,
                    "color": "secondary",
                    "x-small": "",
                    "text": ""
                  }
                }, 'v-btn', attrs, false), on), [_vm._v("\n                                    More...\n                                  ")])]
              }
            }], null, true)
          }, [_vm._v(" "), _c('v-card', {
            staticStyle: {
              "text-align": "left"
            },
            attrs: {
              "max-width": "300"
            }
          }, [_c('v-card-text', [_c('div', [_vm._v("Audience Interests")]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _vm._l((item.audience_interests), function(interest, index) {
            return _c('div', {
              key: index,
              staticClass: "d-flex justify-space-between"
            }, [_c('v-chip', {
              staticClass: "ma-2",
              attrs: {
                "x-small": ""
              }
            }, [_vm._v(_vm._s(interest.name))]), _vm._v(" "), _c('span', {
              staticStyle: {}
            }, [_vm._v("(" + _vm._s((interest.weight * 100).toFixed(2)) + "%)")])], 1)
          })], 2)], 1)], 1)], 2) : _vm._e(), _vm._v(" "), (_vm.displayFields('engagement')) ? _c('td', {
            attrs: {
              "align": "center"
            }
          }, [(item.engagement_rate && item.engagement_rate !== '0.00') ? _c('span', [_vm._v(_vm._s(item.engagement_rate) + "%")]) : (item.engagement_rate === '0.00') ? _c('span', {
            staticClass: "caption"
          }, [_c('v-icon', {
            attrs: {
              "small": "",
              "data-toggle": "tooltip",
              "data-placement": "top",
              "title": "Hidden"
            }
          }, [_vm._v("mdi-eye-off")])], 1) : _c('span', [_vm._v("-")])]) : _vm._e(), _vm._v(" "), (_vm.displayFields('rateCard')) ? _c('td', {
            attrs: {
              "align": "center"
            }
          }, [_c('v-hover', {
            scopedSlots: _vm._u([{
              key: "default",
              fn: function(ref) {
                var hover = ref.hover;

                return [(item.rateCard) ? _c('v-chip', {
                  staticClass: "ma-2",
                  class: {
                    'on-hover': hover
                  },
                  attrs: {
                    "color": "primary",
                    "x-small": "",
                    "text-color": "white",
                    "elevation": hover ? 12 : 2
                  },
                  on: {
                    "click": function($event) {
                      return _vm.openRateCardView(item.rateCard)
                    }
                  }
                }, [_vm._v("\n                                View Details\n                              ")]) : _vm._e()]
              }
            }], null, true)
          }), _vm._v(" "), (item.rateCard) ? _c('div', {
            staticStyle: {
              "font-size": "13px"
            }
          }, [_vm._v("\n                              (" + _vm._s(_vm.formatUploadedDate(item.rateCard.createdAt)) + ")\n                            ")]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.displayFields('eliminationStatus')) ? _c('td', {
            attrs: {
              "align": "center"
            }
          }, [(item.eliminationStatus === _vm.eliminationStatus.NEW) ? _c('v-chip', {
            staticClass: "ma-2",
            attrs: {
              "color": "primary",
              "x-small": "",
              "text-color": "white"
            }
          }, [_vm._v("\n                              New\n                              "), _c('v-icon', {
            attrs: {
              "right": "",
              "x-small": ""
            }
          }, [_vm._v("new_releases")])], 1) : _vm._e(), _vm._v(" "), (item.eliminationStatus === _vm.eliminationStatus.PENDING) ? _c('v-tooltip', {
            attrs: {
              "bottom": ""
            },
            scopedSlots: _vm._u([{
              key: "activator",
              fn: function(ref) {
                var on = ref.on;

                return [_c('v-chip', _vm._g({
                  staticClass: "ma-2",
                  attrs: {
                    "color": "primary",
                    "x-small": "",
                    "text-color": "white"
                  }
                }, on), [_vm._v("\n                                  Pending Client\n                                  "), _c('v-icon', {
                  attrs: {
                    "right": "",
                    "x-small": ""
                  }
                }, [_vm._v("loop")])], 1)]
              }
            }], null, true)
          }, [_vm._v(" "), _c('span', [_vm._v("Pending Client's Response")])]) : _vm._e(), _vm._v(" "), (item.eliminationStatus === _vm.eliminationStatus.SELECTED) ? _c('v-tooltip', {
            attrs: {
              "bottom": ""
            },
            scopedSlots: _vm._u([{
              key: "activator",
              fn: function(ref) {
                var on = ref.on;

                return [_c('v-chip', _vm._g({
                  staticClass: "ma-2",
                  attrs: {
                    "color": "#8BC34A",
                    "x-small": "",
                    "text-color": "white"
                  }
                }, on), [_vm._v("\n                                  Selected\n                                  "), _c('v-icon', {
                  attrs: {
                    "right": "",
                    "x-small": ""
                  }
                }, [_vm._v("mdi-check")])], 1)]
              }
            }], null, true)
          }, [_vm._v(" "), _c('span', [_vm._v("Client selected this influencer")])]) : _vm._e(), _vm._v(" "), (item.eliminationStatus === _vm.eliminationStatus.ELIMINATED) ? _c('v-tooltip', {
            attrs: {
              "bottom": ""
            },
            scopedSlots: _vm._u([{
              key: "activator",
              fn: function(ref) {
                var on = ref.on;

                return [_c('v-chip', _vm._g({
                  staticClass: "ma-2",
                  attrs: {
                    "color": "red",
                    "x-small": "",
                    "text-color": "white"
                  },
                  on: {
                    "click": function($event) {
                      return _vm.showReason(item.eliminationReason)
                    }
                  }
                }, on), [_vm._v("\n                                  Eliminated\n                                  "), _c('v-icon', {
                  attrs: {
                    "x-small": ""
                  }
                }, [_vm._v("mdi-close")])], 1)]
              }
            }], null, true)
          }, [_vm._v(" "), _c('span', [_vm._v("Click to view the reason")])]) : _vm._e(), _vm._v(" "), (!item.success && !item.isLoading) ? _c('v-chip', {
            staticClass: "ma-2",
            attrs: {
              "color": "red",
              "x-small": "",
              "text-color": "white"
            }
          }, [_vm._v("Fail")]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.showFrozenPairingColumns && _vm.displayFields('AIPayout')) ? _c('td', {
            staticClass: "pairing-freeze-deliverables",
            attrs: {
              "align": "center"
            }
          }, [_c('p', {
            staticClass: "deliverable-txt mb-0"
          }, [_vm._v("\n                              " + _vm._s(_vm.formatPairingDeliverables(_vm.campaignHelper.getDeliverableDetails(item.deliverableDetails))) + "\n                            ")]), _vm._v(" "), (!_vm.disableLockedCOGS) ? _c('v-icon', {
            attrs: {
              "small": "",
              "color": "secondary",
              "data-toggle": "tooltip",
              "data-placement": "top",
              "title": "Edit"
            },
            on: {
              "click": function($event) {
                return _vm.priceMultiplierHandler(item)
              }
            }
          }, [_vm._v("edit")]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.showFrozenPairingColumns && item.payoutEdit === false && _vm.displayFields('payout')) ? _c('td', {
            staticClass: "pairing-freeze-payout",
            staticStyle: {
              "cursor": "pointer"
            },
            attrs: {
              "align": "center"
            }
          }, [_c('v-tooltip', {
            attrs: {
              "bottom": ""
            },
            scopedSlots: _vm._u([{
              key: "activator",
              fn: function(ref) {
                var on = ref.on;

                return [_c('div', _vm._g({}, on), [_vm._v("\n                                  " + _vm._s(_vm.utilsFunc.currencySym(item.currency)) + "\n                                  " + _vm._s(_vm._f("thousandSeprator")(item.payoutAmount)) + "\n                                  "), (item.isGST) ? _c('v-icon', {
                  attrs: {
                    "small": "",
                    "color": "secondary",
                    "data-toggle": "tooltip",
                    "data-placement": "top",
                    "title": "GST enabled"
                  }
                }, [_vm._v("mdi-alert-circle-outline")]) : _vm._e(), _vm._v(" "), (!_vm.isAdmin && _vm.disableLockedCOGS) ? _c('v-icon', {
                  attrs: {
                    "small": "",
                    "color": "secondary",
                    "data-toggle": "tooltip",
                    "data-placement": "top",
                    "title": "Locked COGS"
                  },
                  on: {
                    "click": function($event) {
                      return _vm.openLockedCOGSDialog(_vm.campaign)
                    }
                  }
                }, [_vm._v("mdi-lock")]) : (item.payoutStatus == _vm.payoutStatus.CONFIRMED && _vm.isPendingActivity(item)) ? _c('v-icon', {
                  attrs: {
                    "small": "",
                    "color": "secondary",
                    "data-toggle": "tooltip",
                    "data-placement": "top",
                    "title": "Pending Payouts"
                  },
                  on: {
                    "click": function($event) {
                      return _vm.openLockedPayoutEditDialog(item)
                    }
                  }
                }, [_vm._v("mdi-clock-alert-outline")]) : (item.payoutStatus == _vm.payoutStatus.CONFIRMED && !_vm.isPendingActivity(item)) ? _c('v-icon', {
                  attrs: {
                    "small": "",
                    "color": "secondary",
                    "data-toggle": "tooltip",
                    "data-placement": "top",
                    "title": "Locked"
                  },
                  on: {
                    "click": function($event) {
                      return _vm.openLockedPayoutEditDialog(item)
                    }
                  }
                }, [_vm._v("mdi-lock")]) : _c('v-icon', {
                  attrs: {
                    "small": "",
                    "color": "secondary",
                    "data-toggle": "tooltip",
                    "data-placement": "top",
                    "title": "Edit"
                  },
                  on: {
                    "click": function($event) {
                      return _vm.openPayoutEditDialog(item)
                    }
                  }
                }, [_vm._v("edit")])], 1)]
              }
            }], null, true)
          }, [_vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.displayGSTText(item)))]), _c('br'), _vm._v(" "), (item.sgdAmt) ? _c('span', [_vm._v("Estimated SGD: " + _vm._s(item.sgdAmt))]) : _vm._e()])], 1) : _vm._e(), _vm._v(" "), (_vm.showFrozenPairingColumns && item.payoutEdit === true && _vm.displayFields('payout')) ? _c('td', {
            staticClass: "pairing-freeze-payout",
            staticStyle: {
              "cursor": "pointer"
            },
            attrs: {
              "align": "center"
            }
          }, [_c('v-text-field', {
            staticClass: "mt-3",
            staticStyle: {
              "width": "100px"
            },
            attrs: {
              "dense": "",
              "outlined": ""
            },
            model: {
              value: (item.payoutAmount),
              callback: function($$v) {
                _vm.$set(item, "payoutAmount", $$v)
              },
              expression: "item.payoutAmount"
            }
          })], 1) : _vm._e(), _vm._v(" "), (_vm.showFrozenPairingColumns && item.statusEdit === false && _vm.displayFields('pairingStatus')) ? _c('td', {
            staticClass: "pairing-freeze-pairing",
            attrs: {
              "align": "center"
            },
            on: {
              "click": function($event) {
                return _vm.openEditItem(item.pairingID, 'status')
              }
            }
          }, [_c('v-chip', {
            staticClass: "ma-2",
            attrs: {
              "outlined": "",
              "x-small": ""
            }
          }, [_vm._v("\n                              " + _vm._s(_vm.getPairingStatusLabels(item.pairingStatus)) + "\n                              "), (item.payoutStatus == _vm.payoutStatus.CONFIRMED) ? _c('v-icon', {
            attrs: {
              "right": "",
              "x-small": ""
            }
          }, [_vm._v("mdi-lock")]) : _c('v-icon', {
            attrs: {
              "right": "",
              "x-small": ""
            }
          }, [_vm._v("mdi-circle-edit-outline")])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.showFrozenPairingColumns && item.statusEdit === true) ? _c('td', {
            staticClass: "pairing-freeze-pairing",
            attrs: {
              "align": "center"
            }
          }, [_c('v-select', {
            attrs: {
              "items": _vm.acceptPairingStatusOptions,
              "item-value": "status",
              "item-text": "display",
              "label": "Pairing Status"
            },
            on: {
              "change": function($event) {
                return _vm.changePairingStatus(item)
              }
            },
            model: {
              value: (item.pairingStatus),
              callback: function($$v) {
                _vm.$set(item, "pairingStatus", $$v)
              },
              expression: "item.pairingStatus"
            }
          })], 1) : _vm._e()])
        }), 0)]
      }
    }]),
    model: {
      value: (_vm.selectAllStatus),
      callback: function($$v) {
        _vm.selectAllStatus = $$v
      },
      expression: "selectAllStatus"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('loading', {
    attrs: {
      "active": _vm.isLoading,
      "can-cancel": false,
      "is-full-page": true,
      "loader": "bars",
      "background-color": "#000",
      "color": "secondary",
      "width.number": "90",
      "height.number": "90"
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  })], 1)], 1), _vm._v(" "), _c('v-card-actions', {
    staticClass: "ims-modal-actions pairing-modal-actions"
  }, [_c('v-btn-toggle', {
    attrs: {
      "mandatory": "",
      "color": "secondary"
    },
    on: {
      "change": function($event) {
        return _vm.getPairedInfluencers(_vm.campaign.id)
      }
    },
    model: {
      value: (_vm.optionVal),
      callback: function($$v) {
        _vm.optionVal = $$v
      },
      expression: "optionVal"
    }
  }, [_c('v-btn', {
    staticClass: "option-btn",
    class: {
      'secondary': _vm.optionVal === 0
    }
  }, [_vm._v("Option A")]), _vm._v(" "), _c('v-btn', {
    staticClass: "option-btn",
    class: {
      'secondary': _vm.optionVal === 1
    }
  }, [_vm._v("Option B")])], 1), _vm._v(" "), _c('v-spacer'), _vm._v(" "), (_vm.showBtnCO) ? _c('v-btn', {
    attrs: {
      "color": "secondary"
    },
    on: {
      "click": function($event) {
        return _vm.invokeSendToAM()
      }
    }
  }, [_vm._v("Send to AM")]) : _vm._e(), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "secondary"
    },
    on: {
      "click": function($event) {
        return _vm.showPairingEliminEditModal()
      }
    }
  }, [_vm._v("Send To Client")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "secondary",
      "target": "_blank",
      "to": '/campaigns/' + _vm.campaign.id + '/invite-influencer'
    }
  }, [_vm._v("Send Invitation")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "secondary",
      "target": "_blank",
      "to": '/influencers/invoices-brief-confirmation?id=' + _vm.campaign.id
    }
  }, [_vm._v("Invoices & Brief Confirmation")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "secondary",
      "target": "_blank",
      "to": '/finance/payment-consolidation/status?id=' + _vm.campaign.id
    }
  }, [_vm._v("Payment Consolidation Status")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "secondary",
      "text": ""
    },
    on: {
      "click": function($event) {
        return _vm.close()
      }
    }
  }, [_vm._v("Cancel")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('influencer-list-modal', {
    attrs: {
      "value1": _vm.showInfluencerSearchResult,
      "result": _vm.influencerSearchResult,
      "influencers": _vm.selected,
      "keyword": _vm.currentKeywordSearch
    },
    on: {
      "input1": _vm.input1,
      "select": _vm.select
    },
    model: {
      value: (_vm.showInfluencerSearchResult),
      callback: function($$v) {
        _vm.showInfluencerSearchResult = $$v
      },
      expression: "showInfluencerSearchResult"
    }
  }), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "max-width": "400"
    },
    model: {
      value: (_vm.reasonDialog),
      callback: function($$v) {
        _vm.reasonDialog = $$v
      },
      expression: "reasonDialog"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "headline"
  }, [_vm._v("Reason for elimination")]), _vm._v(" "), _c('v-card-text', [_vm._v(_vm._s(_vm.eliminationReason))]), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "secondary",
      "text": ""
    },
    on: {
      "click": function($event) {
        _vm.reasonDialog = false
      }
    }
  }, [_vm._v("OK")])], 1)], 1)], 1), _vm._v(" "), _c('k-toast', {
    attrs: {
      "variant": _vm.toast.variant,
      "header": _vm.toast.header,
      "content": _vm.toast.content
    }
  }), _vm._v(" "), _c('settings-for-ai-modal', {
    attrs: {
      "value": _vm.settingAIDialog
    },
    on: {
      "paramsUpdated": function($event) {
        return _vm.paramsUpdated()
      }
    },
    model: {
      value: (_vm.settingAIDialog),
      callback: function($$v) {
        _vm.settingAIDialog = $$v
      },
      expression: "settingAIDialog"
    }
  }), _vm._v(" "), _c('settings-for-pairing', {
    attrs: {
      "value": _vm.updatePairingDialog,
      "view-only": _vm.viewOnly,
      "data": _vm.activePairingData
    },
    on: {
      "pairChanged": function($event) {
        return _vm.pairChanged()
      }
    },
    model: {
      value: (_vm.updatePairingDialog),
      callback: function($$v) {
        _vm.updatePairingDialog = $$v
      },
      expression: "updatePairingDialog"
    }
  }), _vm._v(" "), _c('price-multiplier-modal', {
    attrs: {
      "value": _vm.priceMultiplierDialog,
      "pairedInfluencer": _vm.priceMultiplierInfluencerData,
      "campaignData": _vm.campaign,
      "multiple": _vm.isMultipleDeliverables,
      "multipleInfs": _vm.actionSelected
    },
    on: {
      "clearSelected": function($event) {
        return _vm.clearActionSelected()
      },
      "savedFromPriceMultplier": function($event) {
        return _vm.pairChanged()
      }
    },
    model: {
      value: (_vm.priceMultiplierDialog),
      callback: function($$v) {
        _vm.priceMultiplierDialog = $$v
      },
      expression: "priceMultiplierDialog"
    }
  }), _vm._v(" "), _c('full-screen-progress', {
    attrs: {
      "show": _vm.bulkProgress.show,
      "isStatus": "true",
      "processing": _vm.bulkProgress.processing,
      "complete": _vm.bulkProgress.complete,
      "color": _vm.secondary
    }
  }), _vm._v(" "), _c('req-cogs-approval-modal', {
    attrs: {
      "value": _vm.reqApprovalDialog,
      "pairing": _vm.payoutEditPairing,
      "amount": _vm.reqAmt,
      "reasons": _vm.reqReasons,
      "budget": _vm.budget,
      "currentCOGS": _vm.measurement.budget,
      "cogsPercent": _vm.measurement.cogsPercentage
    },
    on: {
      "saved": function($event) {
        return _vm.getPairedInfluencers(_vm.campaign.id)
      }
    },
    model: {
      value: (_vm.reqApprovalDialog),
      callback: function($$v) {
        _vm.reqApprovalDialog = $$v
      },
      expression: "reqApprovalDialog"
    }
  }), _vm._v(" "), _c('payout-update-modal', {
    attrs: {
      "value": _vm.editPayoutDialog,
      "pairing": _vm.payoutEditPairing,
      "lockedPayout": _vm.lockedPayout,
      "cappedCOGS": _vm.budget,
      "currentCOGS": _vm.measurement.budget,
      "campaign": _vm.campaign
    },
    on: {
      "budgetExceeded": _vm.openReqApprovalDialog,
      "refreshPairing": function($event) {
        return _vm.getPairedInfluencers(_vm.campaign.id)
      }
    },
    model: {
      value: (_vm.editPayoutDialog),
      callback: function($$v) {
        _vm.editPayoutDialog = $$v
      },
      expression: "editPayoutDialog"
    }
  }), _vm._v(" "), _c('pairing-elimination-edit-modal', {
    attrs: {
      "campaingData": _vm.campaingDataForElimination
    },
    on: {
      "invokeSendToClient": _vm.invokeSendToClient
    },
    model: {
      value: (_vm.eliminationDialog),
      callback: function($$v) {
        _vm.eliminationDialog = $$v
      },
      expression: "eliminationDialog"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6fb1cb00"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Campaign/PairingInfluencer/ViewPairingModal.vue
// module id = 2183
// module chunks = 0